import React from "react"
import { connect } from "react-redux"
import { MainThunkDispatch } from "../../../../Reducers"
import { userForgotPassword } from "../../../../Actions/Auth/AuthActions"
import { safePromise } from "../../../../Helpers/Functions/promise"
import { SingleLineTextInput, Button } from "dash-styled"
import { useInput } from "../../../../Hooks/useInput"

interface ForgotPasswordFormProps {
    onSubmit: () => void
}

interface StateProps {}

interface DispatchProps {
    userForgotPasswordForm: (emailAddress: string) => void
}

export type Props = ForgotPasswordFormProps & StateProps & DispatchProps

export const ForgotPasswordFormIsolated = ({
    userForgotPasswordForm
}: Props) => {
    const email = useInput("", false)
    const handleSubmit = () => userForgotPasswordForm(email.value.toLowerCase())

    return (
        <div className="flex flex-col items-stretch px-4">
            <SingleLineTextInput
                name="email"
                type="email"
                autoComplete="off"
                label="Email"
                value={email.value}
                onChange={email.onChange}
                placeholder="me@company.com"
                className="pb-4"
                testId="forgot-input"
            />
            <Button
                onClick={handleSubmit}
                disabled={!email.isValid}
                className="mt-4 w-64 mx-auto"
                testId="forgot-submit"
            >
                Email me a reset code
            </Button>
        </div>
    )
}

const mapDispatchToProps = (
    dispatch: MainThunkDispatch,
    { onSubmit }: ForgotPasswordFormProps
): DispatchProps => {
    return {
        userForgotPasswordForm: async (email: string) => {
            const { error } = await safePromise(
                dispatch(userForgotPassword(email))
            )

            if (error === undefined) {
                onSubmit()
            }
        }
    }
}

export const ForgotPasswordForm = connect(
    null,
    mapDispatchToProps
)(ForgotPasswordFormIsolated)
